import { render, staticRenderFns } from "./ModulesConfig.vue?vue&type=template&id=7627bc4d&scoped=true"
import script from "./ModulesConfig.vue?vue&type=script&lang=ts"
export * from "./ModulesConfig.vue?vue&type=script&lang=ts"
import style0 from "./ModulesConfig.vue?vue&type=style&index=0&id=7627bc4d&prod&lang=less"
import style1 from "./ModulesConfig.vue?vue&type=style&index=1&id=7627bc4d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_c2c4f8d10a02e12364bd9a7337709f82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7627bc4d",
  null
  
)

export default component.exports